module.exports = __webpack_public_path__ + "images/landing/video-previews/How_To_Bait_Your_Hook_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/How_To_Bait_Your_Hook_2x.jpg
// module id = ktG4
// module chunks = 1